import { cn } from "@faire/prototype-playground/lib/utils";
import { Button } from "@faire/slate/components/button";
import { getEventTheme } from "@faire/web/slate/Theme/eventsThemeColors";
import { EventsThemeLogo } from "@faire/web/slate/Theme/EventsThemeLogo";
import { EventsThemeShapeCombination } from "@faire/web/slate/Theme/EventsThemeShapeCombination";
import React from "react";

import { CREAM, PADX } from "../constants";

interface FaireMarketBannerProps {
  backgroundColor?: string;
}

// Faire Market has its own event-theme palette (burgundy #56160c) — keep the
// banner on that system, independent of the brand's hero color block.
const FAIRE_MARKET_BURGUNDY = getEventTheme("faireMarket").primaryDark;

export const FaireMarketBanner: React.FC<FaireMarketBannerProps> = ({
  backgroundColor = FAIRE_MARKET_BURGUNDY,
}) => (
  <div className={cn("py-8", PADX)}>
    <div
      className="relative flex flex-col items-center overflow-hidden rounded-xl px-6 py-16 text-center"
      style={{ backgroundColor }}
    >
      <div className="absolute top-7 left-7 z-10">
        <EventsThemeLogo.faireMarket.primary isInverse height="56" />
      </div>
      <div className="pointer-events-none absolute right-[-40px] bottom-0">
        <EventsThemeShapeCombination.faireMarket.comboA
          frontShapeColor={getEventTheme("faireMarket").decorative6 ?? ""}
          backShapeColor={getEventTheme("faireMarket").decorative5 ?? ""}
          width="320px"
          height="200px"
        />
      </div>
      <div className="relative z-[1] flex flex-col items-center gap-4">
        <p className="type-fs-paragraph" style={{ color: CREAM }}>
          July 21–23, plus Insider early access
        </p>
        <p className="type-fs-display-s max-w-2xl" style={{ color: CREAM }}>
          We&apos;ll be at Faire Market!
        </p>
        <p className="type-fs-paragraph max-w-xl" style={{ color: CREAM }}>
          Shop the best deals on our brand at Faire&apos;s 4-day online buying
          event. The event is free for all Faire retailers!
        </p>
        <Button variant="secondary" size="small">
          Learn More
        </Button>
      </div>
    </div>
  </div>
);
